import { BenefitDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class ITLeasingBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/it_leasing',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.description.info`,
      benefitProgress: 100,
    };
  }
}
